import { DataAction } from '../@types';

const actionType = 'error';

export type ErrorAction = DataAction<typeof actionType, string>;

export function error(data: string): ErrorAction {
	return {
		data,
		type: actionType
	};
}
